/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PreOpsAnswerChoice } from './PreOpsAnswerChoice';
import {
    PreOpsAnswerChoiceFromJSON,
    PreOpsAnswerChoiceFromJSONTyped,
    PreOpsAnswerChoiceToJSON,
    PreOpsAnswerChoiceToJSONTyped,
} from './PreOpsAnswerChoice';

/**
 * 
 * @export
 * @interface PreOpsAnswer
 */
export interface PreOpsAnswer {
    /**
     * 
     * @type {string}
     * @memberof PreOpsAnswer
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof PreOpsAnswer
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof PreOpsAnswer
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof PreOpsAnswer
     */
    vehicleId: string;
    /**
     * 
     * @type {Date}
     * @memberof PreOpsAnswer
     */
    time: Date;
    /**
     * 
     * @type {string}
     * @memberof PreOpsAnswer
     */
    answerGroupId: string;
    /**
     * 
     * @type {string}
     * @memberof PreOpsAnswer
     */
    questionVersionId: string;
    /**
     * 
     * @type {PreOpsAnswerChoice}
     * @memberof PreOpsAnswer
     */
    choice: PreOpsAnswerChoice;
}



/**
 * Check if a given object implements the PreOpsAnswer interface.
 */
export function instanceOfPreOpsAnswer(value: object): value is PreOpsAnswer {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('answerGroupId' in value) || value['answerGroupId'] === undefined) return false;
    if (!('questionVersionId' in value) || value['questionVersionId'] === undefined) return false;
    if (!('choice' in value) || value['choice'] === undefined) return false;
    return true;
}

export function PreOpsAnswerFromJSON(json: any): PreOpsAnswer {
    return PreOpsAnswerFromJSONTyped(json, false);
}

export function PreOpsAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreOpsAnswer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'userId': json['userId'],
        'vehicleId': json['vehicleId'],
        'time': (new Date(json['time'])),
        'answerGroupId': json['answerGroupId'],
        'questionVersionId': json['questionVersionId'],
        'choice': PreOpsAnswerChoiceFromJSON(json['choice']),
    };
}

export function PreOpsAnswerToJSON(json: any): PreOpsAnswer {
    return PreOpsAnswerToJSONTyped(json, false);
}

export function PreOpsAnswerToJSONTyped(value?: PreOpsAnswer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'userId': value['userId'],
        'vehicleId': value['vehicleId'],
        'time': value['time'].toISOString(),
        'answerGroupId': value['answerGroupId'],
        'questionVersionId': value['questionVersionId'],
        'choice': PreOpsAnswerChoiceToJSON(value['choice']),
    };
}

